import React from 'react'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App'
import './index.css'
import './i18n' // Initialize i18n
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
)

// Register service worker for PWA
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('[PWA] App is ready to work offline')
  },
  onUpdate: () => {
    console.log('[PWA] New version available. Please refresh.')
  },
})
